import React from 'react'
import { Box, HoverCard, Link, Text } from 'components/ds'

type Props = {
  children: React.ReactNode
}

const BannerImageRecommendationsHoverCard = ({
  children,
}: Props): React.ReactNode => {
  return (
    <HoverCard.Root>
      <HoverCard.Trigger>{children}</HoverCard.Trigger>
      <HoverCard.Content size="2" maxWidth="320px">
        <Text as="p" size="2" weight="bold" mb="2">
          Banner image recommendations
        </Text>
        <Box asChild mb="3" px="5">
          <Text size="2" asChild>
            <ul>
              <li>File format: JPEG or PNG</li>
              <li>Aspect ratio: 3:1 (landscape)</li>
              <li>Minimum dimensions: 2400 x 800px</li>
              <li>Position key content (e.g. faces, text) in the center</li>
            </ul>
          </Text>
        </Box>
        <Text as="p" size="2">
          Get more tips from our{' '}
          <Link
            href="https://support.disco.ac/home/catalogs-guide#recommended-image-specifications-for-disco-catalogs-artist-pages-and-album-pages"
            target="_blank"
            rel="noopener noreferrer"
          >
            FAQs
          </Link>
        </Text>
      </HoverCard.Content>
    </HoverCard.Root>
  )
}

export default BannerImageRecommendationsHoverCard
